/**
 * Confetti palette + physics tuning. The look is intentionally fixed brand
 * styling; every "feel" knob lives here.
 */

import type { ParticleShape } from "@/interfaces/redemption";

// Foil palette — [front, back] pairs pulled from the GfG @theme ramps. The two
// faces alternate as a piece tumbles, giving a metallic sheen. Warm champagne /
// gold tones lead; sage, wine and night are accent pops; ink adds depth.
export const FOIL: readonly (readonly [string, string])[] = [
  ["#ac8958", "#f3e3cd"], // ochre gold — hero
  ["#8a5d1f", "#cfb591"], // deep gold
  ["#af9577", "#c8b298"], // champagne dust
  ["#637058", "#b5bbaf"], // sage
  ["#bb7570", "#eed4d3"], // wine
  ["#5e798c", "#c7d9e6"], // night blue
  ["#f4efea", "#ffffff"], // cream sparkle
  ["#333333", "#6d6d6d"], // ink
];
// Weighted bag — warm tones dominate, accents + ink stay sparse.
export const BAG = [0, 0, 0, 1, 1, 2, 2, 2, 3, 4, 5, 6, 6, 7];

// ── TUNING — dial the feel here ─────────────────────────────────────────────
export const PER_CANNON = 150; // per cannon per beat → 150 × 2 cannons × 2 beats ≈ 600
export const SECOND_BEAT_MS = 180; // follow-up burst; turns a single "pop" into an "event"
// Right cannon (and its soft-pop cue) fire this long after the left — organic, not
// one symmetric hit. Also used to stagger the audio cues to match the visual.
export const CANNON_STAGGER_MS = 110;
export const LAUNCH_MIN = 14; // launch speed range, px/frame
export const LAUNCH_MAX = 24;
export const SPREAD_DEG = 20; // angular spread each side of a cannon's aim
export const GRAVITY = 0.3; // px/frame² — snappy launch + apex
export const TERMINAL = 4.5; // px/frame — capped fall = slow, lingering flutter
export const DRAG = 0.99; // horizontal air resistance
export const FADE_START_MS = 3400; // hold full opacity, then fade the stragglers
export const FADE_MS = 1500;
export const MAX_LIFE_MS = 6500; // hard stop

export const TWO_PI = Math.PI * 2;

// Every concrete shape, for the `mixed` random pick.
export const ALL_SHAPES: readonly ParticleShape[] = [
  "teardrop",
  "heart",
  "star",
  "rect",
  "circle",
  "oval",
];
